import { render, staticRenderFns } from "./FornecedoresTable.vue?vue&type=template&id=cc858e72"
import script from "./FornecedoresTable.vue?vue&type=script&lang=js"
export * from "./FornecedoresTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports